import React from 'react'
import Footer from '../../Footer'
import ImageGallery from 'react-image-gallery';
import '../Proj.css'
import p1 from '../../../img/illust/BerlinTravel/1.png'
import p2 from '../../../img/illust/BerlinTravel/2.png'
import p3 from '../../../img/illust/BerlinTravel/3.png'
import p4 from '../../../img/illust/BerlinTravel/4.png'
import p5 from '../../../img/illust/BerlinTravel/5.png'
import p6 from '../../../img/illust/BerlinTravel/6.png'
import p7 from '../../../img/illust/BerlinTravel/7.png'
import p8 from '../../../img/illust/BerlinTravel/8.png'
import p9 from '../../../img/illust/BerlinTravel/9.png'
import p10 from '../../../img/illust/BerlinTravel/10.png'
import p11 from '../../../img/illust/BerlinTravel/11.png'

const images = [
    {
      original: p1,
      thumbnail: p1,
    },{
    original: p2,
    thumbnail: p2,
    },{
    original: p3,
    thumbnail: p3,
    },{
    original: p4,
    thumbnail: p4,
    },{
    original: p5,
    thumbnail: p5,
    },{
    original: p6,
    thumbnail: p6,
    },{
    original: p7,
    thumbnail: p7,
    },{
    original: p8,
    thumbnail: p8,
    },{
    original: p9,
    thumbnail: p9,
    },{
    original: p10,
    thumbnail: p10,
    },{
    original: p11,
    thumbnail: p11,
    },
];


export default class ProjBerlinTravel extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div className='proj-wrap-86'>
                    <div id='illust-title'>
                        <h1>Trip to Berlin, 2019 Summer</h1>
                        <p >I was chosen to be one of the six student ambassadors of the governments' Overseas Community Affairs Council and got the precious opportunity to visit Berlin for one week.</p>
                    </div>
                </div>
                <div className='proj-image-gallery'>
                    <ImageGallery items={images} />
                </div>
                <Footer back={true}/>
            </div>
                
            
        )
    }
}